const sectionCode = "SPRO2";
const chartCode = "C046x";

import { Procedures } from "modules/provider/shared/procedure-charts";

function T46Procedures() {
  return <Procedures chartCode={chartCode} sectionCode={sectionCode} />;
}

export { T46Procedures };
